export const ButtonVariant = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    OUTLINE: "outline",
    GHOST: "ghost",
    DANGER: "danger",
    DARK: "dark",
    ACCENT: "accent"
};

export const ButtonSize = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};